export type InstallationSite = "production" | "beta";

export interface InstallationStatus {
  site: InstallationSite;
  verifiedSite: InstallationSite | null;
  warning?: string;
}

export interface InstallationPlugin {
  getStatus(): Promise<InstallationStatus>;
  check(): Promise<InstallationStatus>;
  switchToBeta(): Promise<void>;
  switchToProduction(): Promise<void>;
}

export function installationPlugin(): InstallationPlugin | undefined {
  if (window.Capacitor?.getPlatform?.() !== "ios") return undefined;
  return window.Capacitor.Plugins?.WirderInstallation;
}

export function displayedVersion(
  version: string,
  site?: InstallationSite,
  hostname = window.location.hostname,
): string {
  const beta = site ? site === "beta" : hostname === "beta.wirdergame.com";
  return `${version}${beta ? " Beta" : ""}`;
}

export function installationErrorMessage(error: unknown): string {
  if (error instanceof Error &&
      error.message.startsWith("Could not determine the installation channel.")) {
    return error.message;
  }
  return "Could not determine the installation channel. You can keep using this site.";
}
